<template lang="html">
<div>
     <div class="toast" v-if="showToast">
          <div class="toast-inner">
               <span>{{toastText}}</span>
          </div>
    </div>
</div>
</template>

<script>

import vEmits from "@/utils/vEmits";
let tempStore = {};

export default {
    data(){
         return{
              toastText:'',
              showToast:false
         }
    },
    methods:{
         show:function(text){
              this.toastText = text;
              this.showToast = true;
              this.hide();
         },
         hide:function(){
              let vs = this;
              if(vs.wait){
                  clearTimeout(vs.wait);
              }
              vs.wait = setTimeout(function(){
                  vs.showToast = false;
              },2000)

         }
    },
    mounted:function(){
         let vues = this;
         vEmits.$on('show',function(e){
             vues.show(e);
         })
    }
}
</script>

<style lang="css" scoped>

.toast{
     position: fixed;
     z-index: 99;
     left: 50%;
     top: 45%;
     width: 300px;
     height: 60px;
     margin-left: -150px;
     margin-top: -30px;
     display: flex;
     align-items: center;

     animation-name: show;
     animation-duration: 0.15s;
     animation-fill-mode: forwards;
}

@keyframes show {
     from{
         opacity: 0;
         transform: scale(0.9);
         -webkit-transform: scale(0.9);
     }
     to{
         opacity: 1;
         transform: scale(1);
         -webkit-transform: scale(1);
     }
}

.toast-inner{
     position: relative;
     padding: 9px 18px;
     background: rgba(0,0,0,0.6);
     color: white;
     font-size: 14px;
     margin: 0 auto;
     border-radius: 3px;
}

</style>
